var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gallery"}},[_c('p',{staticClass:"g-lead"},[_vm._v("Select apartment main image")]),_c('div',{staticClass:"g-items"},[_c('GalleryItem',{attrs:{"featured":true,"current-image":false,"new-image":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }